import { render, staticRenderFns } from "./ListDocumentsItem.vue?vue&type=template&id=725e3b8b&scoped=true&"
import script from "./ListDocumentsItem.vue?vue&type=script&lang=js&"
export * from "./ListDocumentsItem.vue?vue&type=script&lang=js&"
import style0 from "./ListDocumentsItem.vue?vue&type=style&index=0&id=725e3b8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e3b8b",
  null
  
)

export default component.exports